import { createTheme, ThemeProvider, Tooltip } from '@mui/material';
import React from 'react';

interface ToolTipCircleProps {
  lgSize: '2xs' | 'xs' | 'sm' | 'base' | 'lg' | 'lg2' | 'xl' | '2xl' | '3xl';
  xlgSize: '2xs' | 'xs' | 'sm' | 'base' | 'lg' | 'lg2' | 'xl' | '2xl' | '3xl';
  text: string;
  placement?: 'bottom' | 'right' | 'left' | 'top' | any;
}

export const ToolTipCircle: React.FC<ToolTipCircleProps> = ({ lgSize, text, xlgSize, placement }) => (
  <Tooltip title={text} arrow className={`shadow-md text-${lgSize}`} placement={placement}>
    <i className={`icon-information_sel  xl:text-${xlgSize} lg:text-${lgSize} text-white bg-black rounded-full `}></i>
  </Tooltip>
);

const theme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: { padding: 0, backgroundColor: 'transparent' },
        arrow: { color: '#9c9c9c' },
      },
    },
  },
});

export const HtmlTooltip: React.FC<{ text: string; placement?: any }> = ({ text, placement }) => (
  <ThemeProvider theme={theme}>
    <Tooltip title={text} arrow className="shadow-md" placement={placement}>
      <i className={`icon-information_sel  text-white bg-black rounded-full `}></i>
    </Tooltip>
  </ThemeProvider>
);
